// ABOUTME: Dynamic z-index manager for stacking portals, modals, sidebars, tooltips
// ABOUTME: Later opened elements automatically get higher z-index values

const BASE_Z_INDEX = 10000
export const Z_INDEX_STEP = 10

let currentZIndex = BASE_Z_INDEX

/**
 * Get the next available z-index value.
 * Each call increments the counter, so later elements appear above earlier ones.
 */
export const getNextZIndex = (): number => {
  currentZIndex += Z_INDEX_STEP
  return currentZIndex
}

/**
 * Get current z-index without incrementing (for reading current level)
 */
export const getCurrentZIndex = (): number => {
  return currentZIndex
}

/**
 * Reset z-index to base value (useful for testing or full page resets)
 */
export const resetZIndex = (): void => {
  currentZIndex = BASE_Z_INDEX
}
